/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.FormMetadataRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetFormMetadataRequest = {
  formGuid: string;
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type GetFormMetadataResponse = {
  formGuid: string;
  formCreatedByEditorV2: boolean;
};

export type PortalAuthError = {
  reason: PortalAuthErrorReason;
  portalInstanceId?: number;
  denialReason?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type PortalAuthErrorReason =
  | 'AUTHENTICATION_FAILED'
  | 'ACCESS_DENIED'
  | 'UNEXPECTED_ERROR'
  | 'INVALID_PARAMETER_COUNT'
  | 'INVALID_PARAMETER_TYPES'
  | 'MISSING_ACCOUNT_ID'
  | 'MISSING_PORTAL_INSTANCE_ID'
  | 'MISSING_MEMBERSHIP_COOKIE'
  | 'EMPTY_MEMBERSHIP_COOKIE'
  | 'CSRF_ERROR'
  | 'MISSING_CRM_OBJECT_ID'
  | 'MISSING_CRM_OBJECT_ASSOCIATION'
  | 'FORM_NOT_FOUND'
  | unhandledEnumCase;

export type GetFormMetadataRequestType = Requestify<GetFormMetadataRequest>;
export type GetFormMetadataResponseType = GetFormMetadataResponse;
export type GetFormMetadataErrorType = PortalAuthError & HubspotMetadata;
export const getFormMetadataRpc: ChirpAvroRpcDetails<
  GetFormMetadataRequestType,
  GetFormMetadataResponseType,
  GetFormMetadataErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.FormMetadataRpc',
  rpcName: 'getFormMetadata',
  auth: 'external',
  fingerprint: 'dwXsqG0gPCgM5-fkfQY-aEWCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
